import React from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { urls } from "../../config/routes";
import GalleryHandler from "../../components/GalleryHandler";

const CaseMediaRoutes = () => {
  const { data } = useSelector(state => state.media);
  return (
    <Route
      path={urls.caseMediaDetail}
      exact
      render={renderProps =>
        data &&
        data.length > 0 && (
          <GalleryHandler
            {...renderProps}
            data={data}
            defaultRoute={urls.caseMedia}
            detailRoute={urls.caseMediaDetail}
            view="media"
          />
        )
      }
    />
  );
};

export default CaseMediaRoutes;
